/* eslint-disable */

import Vue from 'vue';
import { createApp } from 'vue'
import router from './router';
import store from './store/index';

import { fakeBackend } from './_helpers';

fakeBackend();

import { initFacebookSdk, jwtInterceptor } from './_helpers';

// enable interceptors for http requests
jwtInterceptor();
// errorInterceptor();

// wait for facebook sdk to start app
initFacebookSdk().then(createApp);

import Amplify from 'aws-amplify';
import awsconfig from './aws-exports';

import { Auth, API, Logger } from "aws-amplify";

Amplify.configure(awsconfig);

// Vue.use(Auth);
// Vue.use(API);

Logger.LOG_LEVEL = "ERROR";

// const logger = new Logger("main");

// Vue.config.productionTip = false

// export const bus = new Vue();

import dotenv from 'dotenv'
const config = dotenv.config()
import App from './App.vue'
import { i18n } from '@/plugins/i18n'
import mitt from 'mitt'

const emitter = mitt()

import VueNextSelect from 'vue-next-select'
import VueMobileDetection from "vue-mobile-detection";


const app = createApp(App)

app.use(router)
app.use(store)

app.use(i18n)

app.use(Auth)
app.use(API)
app.use(VueMobileDetection);

app.component('vue-select', VueNextSelect)

app.config.devtools = false

app.config.errorHandler = () => null;
app.config.warnHandler = () => null;

app.config.globalProperties.emitter = emitter


app.mount('#app')
